import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VistaRegistroActividadContainerComponent } from '../vista-registro-actividad/components/vista-registro-actividad-container/vista-registro-actividad-container.component';
import { VistaStepperRegistroActividadContainerComponent } from '../vista-stepper-registro-actividad/components/vista-stepper-registro-actividad-container/vista-stepper-registro-actividad-container.component';
import { RegistroActividadLaboratorioFormContainerComponent } from './registro-actividad-laboratorio-form/registro-actividad-laboratorio-form-container/registro-actividad-laboratorio-form-container.component';


const routes: Routes = [
  {
    path: 'seleccion',
    component: VistaRegistroActividadContainerComponent
  },
  {
    path: 'modificacion',
    component: VistaStepperRegistroActividadContainerComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ActividadesRoutingModule { }
